import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/avatar-default.png'
import _imports_1 from '@/assets/image/icon/question.png'


const _withScopeId = n => (_pushScopeId("data-v-fef04c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transfer-title" }
const _hoisted_2 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  class: "abs shop-icon"
}
const _hoisted_3 = { class: "flex-ter shop-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-ter shop-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tips flex-ter" }
const _hoisted_9 = { style: {"width":"300px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1
}, null, -1))
const _hoisted_11 = { class: "flex-end" }

import { t } from '@/plugins/i18n'
import { FormInstance, ElMessage } from 'element-plus'
import { ref, reactive, computed, watch } from 'vue'
import { myShopIcons } from '@/store/modules/bussiness'
import { walletTransferOut } from '@/apis/fund'
import { clearForm } from '@/util/common'
import { useSite, isEN } from '@/store'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  balance: {
    type: Number,
    default: 0
  },
  transferList: {
    type: Array,
    default: () => []
  },
  isSub: {
    type: Boolean,
    default: false
  },
  currencyCode: {
    type: String,
    default: ''
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()


watch(() => props.visible, (newValue) => {
  if (newValue) {
    clearForm(form)
  }
})

const shopPlatform = computed(() => {
  console.log(123, props.transferList, transferAccount.value)
  return (props.transferList as any).find((v: any) => v.customerId === transferAccount.value)?.customerShopPlatform
})

const transferAccount = computed({
  get: () => form.transferToCustomerId,
  set: (v) => {
    const account: any = props.transferList.find((e: any) => e.customerId === v)
    // form.transferToCustomerName = account.customerName
    form.transferToCustomerId = account.customerId
  }
})
const form = reactive({
  transferAmount: '',
  transferToCustomerId: ''
  // transferToCustomerName: ''
})
const rules = {
  transferAmount: [
    { required: true, message: props.currencyCode === 'KRW' ? t('转账金额不能为0KRW') : t('转账金额不能为0'), trigger: 'blur' },
    {
      validator: (rule: any, val: any, callback: any) => {
        if (Number(val) > 0) {
          callback()
        } else {
          callback(props.currencyCode === 'KRW' ? t('转账金额不能为0KRW') : t('转账金额不能为0'))
        }
      },
      trigger: 'blur'
    }
  ],
  transferToCustomerId: [{ required: true, message: t('收件人姓名不能为空'), trigger: 'change' }]
}

const inputPrice: any = (row: any) => {
  // 若是币种为韩元，不能输入小数
  if (props.currencyCode === 'KRW') {
    const num = row.transferAmount.toString().match(/^\d*/g)[0]
    row.transferAmount = num
    return
  }
  const num = row.transferAmount.toString().match(/^\d*(\.?\d{0,2})/g)[0]
  row.transferAmount = num
}
const changePrice: any = (row: any) => {
  const num = row.transferAmount.toString().match(/^\d*(\.?\d{0,2})/g)[0]
  row.transferAmount = num ? Math.min(num, (props.balance || 0)) : ''
}
const formRef = ref<FormInstance>()
const transferLoading = ref(false)
const submit = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      transferLoading.value = true
      walletTransferOut({
        ...form,
        currencyCode: props.currencyCode,
        transferToMain: props.isSub
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('转账成功'))
          emit('update:visible', false)
          emit('refresh')
          store.dispatch('route/changeShop', store.getters['route/getCurShopInfo'].customerShopId)
          setTimeout(() => { transferLoading.value = false }, 1000)
        } else {
          transferLoading.value = false
        }
      }).catch(() => {
        transferLoading.value = false
      })
    } else {
      return false
    }
  })
}




return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "custom-class": 'transfer flex transfer-' + _unref(useSite)(),
    onClose: _cache[7] || (_cache[7] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('转账')), 1),
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        "label-width": _unref(isEN)() ? '230px' : '125px',
        model: _unref(form),
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('收款账号'),
            prop: "transferToCustomerId"
          }, {
            default: _withCtx(() => [
              (__props.isSub)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(transferAccount))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(transferAccount),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(transferAccount) ? (transferAccount).value = $event : null)),
                      class: _normalizeClass({'account-select':_unref(transferAccount)})
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.transferList as any), (v) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: v.customerId,
                            value: v.customerId,
                            label: v.loginName + (v.accountType === 1 ? `(${_unref(t)('主')})` : `(${_unref(t)('子')})`)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(v.loginName) + " (" + _toDisplayString(v.accountType === 1 ? _unref(t)('主') : _unref(t)('子')) + ") ", 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("img", {
                      referrerPolicy: "no-referrer",
                      src: _unref(myShopIcons)[_unref(shopPlatform)],
                      class: "abs shop-icon"
                    }, null, 8, _hoisted_5),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(transferAccount),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(transferAccount) ? (transferAccount).value = $event : null)),
                      class: _normalizeClass({'account-select':_unref(transferAccount)})
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.transferList as any), (v) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: v.customerShopId,
                            value: v.customerId,
                            label: v.customerShopName+(v.accountType === 1 ? `(${_unref(t)('主')})` : `(${_unref(t)('子')})`)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("img", {
                                  referrerPolicy: "no-referrer",
                                  src: _unref(myShopIcons)[v.customerShopPlatform],
                                  class: "mr_5"
                                }, null, 8, _hoisted_7),
                                _createTextVNode(" " + _toDisplayString(v.customerShopName) + " (" + _toDisplayString(v.accountType === 1 ? _unref(t)('主') : _unref(t)('子')) + ") ", 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ], 64))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('金额'),
            prop: "transferAmount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"260px"},
                modelValue: _unref(form).transferAmount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).transferAmount) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (inputPrice(_unref(form)))),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (changePrice(_unref(form))))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('最多可转账金额')) + ":" + _toDisplayString(__props.balance) + " " + _toDisplayString(props.currencyCode === 'KRW' ? _unref(t)('KRW'):_unref(t)('元')), 1),
                (__props.isSub)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "light",
                      placement: "top-start"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额')), 1)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('update:visible', false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: transferLoading.value,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (submit(formRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["label-width", "model"])
    ]),
    _: 1
  }, 8, ["model-value", "custom-class"]))
}
}

})